/**
 * Employee Web — `/me/profile/work` tab route (Plan 05.2-05).
 *
 * Read-only display of position / org-unit / branch / manager / hire-date
 * / contract-type. All fields are HR-managed; no self-edit.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { WorkTab } from "@linkhr/employee-self-service";

export const Route = createFileRoute("/_auth/me/profile/work")({
  staticData: { breadcrumb: { labelKey: "me-profile:tabs.work" } },
  component: WorkTabRoute,
});

function WorkTabRoute(): JSX.Element | null {
  return <WorkTab />;
}
